<template>
<!-- 省市区 -->
    <div class="modal" v-if="showMask">
        <div class="modal-bg"></div>
        <div class="modal-content" ref="monthPie" :style="type != 'normal' ? 'width:340px;' : widthStyle">
            <div class="modal-header">
                <span class="fl">{{title}}</span>
                <a class="close fr" v-if="closeBtn" heaf="javascript:void(0);" @click="closeMask"><img :src="level === '1' ? '/static/images/close.png' : '/static/images/close.png'" class="db"/></a>
            </div>
            <div :class="mainHidden?'modal-warp modal1':'modal-warp modal2'">
                <slot name="mdBox"></slot>
            </div>
            <div class="modal-footer ac" v-if="modalFoot">
                <div v-if="type == 'alert'">
                    <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                </div>
                <div v-if="type != 'alert'">
                    <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                    <button class="btn btn-none" id="closeModal" @click="closeMask" v-if="closeBtn">{{cancelText}}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Dialog",
    props:{
        // dialogShow:{
        //     type:Boolean,
        //     default: true,
        // },
        title:{
            type:String,
            default:function(){
                return '提示';
            },
        },
        level:{
            type:String,
            default:function(){
                return '2';
            },
        },
        width:{
            type:String,
            default:function(){
                return '340';
            },
        },
        type:{
            type:String,
            default:function(){
                return 'normal';
            },
        },
        modalFoot:{
            type:Boolean,
            default: true
        },
        closeBtn:{
            type:Boolean,
            default: true
        },
        btnText:{
            type:String,
            default:function(){
                return '确定';
            },
        },
        callback:{
            type:Function
        },
        callbackDel:{
            type:Function
        },
        iscall:{
            type:Boolean
        },
        mainHidden:{
            type:Boolean,
            default:true,
        }
    },
    data() {
        return {
            showMask: false,
            timer:'',
            loadText:'请稍后.',
            widthStyle:'',
            cancelText:'取消',
        }
    },
    mounted() {
        // this.showMask = this.value;
        this.widthStyle = 'width:'+this.width+'px;';
    },
    created() {

    },
    methods: {
        //打开弹框
        showMaskFun () {
            let that = this;
            that.widthStyle = '';
            that.showMask = true;
            that.$nextTick(() =>{
                that.widthStyle = 'width:'+that.width+'px;';
            })
        },
        closeMask(){
            // clearInterval(this.timer);
            this.showMask = false;
            if(this.iscall){
                this.callbackDel();
            }

            // $(".modal-content").height(this.height);
        },
        dangerBtn(){
            let that = this;
            // if(that.load == true){
            //     return;
            // }
            if(that.type === 'alert'){
                this.showMask = false;
                return;
            }
            let num = 0;
            this.callback();
            // setTimeout(() => {
            //     if(this.dialogShow == true){
            //         this.closeMask();
            //     }
            // }, 1);
        }
    }
}
</script>
<style>
.modal1{
  max-height: 70vh;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue